import { createRouter, createWebHistory } from "vue-router";
import { routes, ROUTE_NAMES } from "./routes";
import { useAuthStore } from "@/stores/auth";
import { useUiStore } from "@/stores/ui";
import { storeToRefs } from "pinia";
import { useAuthentication } from "@/composables/authentication";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
});

router.beforeEach((to, from, next) => {
  const $uiStore = useUiStore();
  const { isLoading } = storeToRefs($uiStore);
  isLoading.value = true;
  next();
});

router.afterEach(() => {
  const $uiStore = useUiStore();
  const { isLoading } = storeToRefs($uiStore);
  isLoading.value = false;
});

router.beforeResolve(async (to, from, next) => {
  const $uiStore = useUiStore();
  const authStore = useAuthStore();
  const auth = useAuthentication();

  await authStore.initializeAuthentication();

  // if anonymous access is enabled
  if (
    to.meta.requiresAuthentication &&
    to.meta.requiresAuthentication === false
  ) {
    next();
    return;
  }

  try {
    await authStore.authenticate();

    if (authStore.isAuthenticated) {
      if (to.meta.requireRoles) {
        if (!auth.isInRole([to.meta.requireRoles as string])) {
          next({ name: ROUTE_NAMES.ACCESS_DENIED });
          return;
        }
      }
      next();
      return;
    }

    await authStore.logIn();
  } catch (error) {
    console.error("Authentication Failed: ", error);
    $uiStore.addToast(
      "failed-authentication",
      "Failed Authentication",
      "error",
      error,
    );
  }
});

export default router;
